import React, { FC } from 'react';
import { CanvasInfo } from '../../../model/BadgeModel';
import { GraphicPageMode } from '../../../model/GraphicModel';
import { MapNamesBar } from './MapNamesBar';
import { MiniMap } from './MiniMap';
import { ZoomMenuBar } from './ZoomMenuBar';

type Props = {
	isQuickAccessOpened: boolean;
	isBirdEyeOpened: boolean;
} & CanvasInfo;

export const FloatingItems: FC<Props> = ({
	isBirdEyeOpened,
	isQuickAccessOpened,
	isMaps,
	containerId,
	mainContainerId,
	viewMode,
	redlineConfiguration,
	graphicActionType,
	disableOptions,
}) => {
	const isDesignMode = viewMode === GraphicPageMode.Design;

	return (
		<>
			{isDesignMode && isQuickAccessOpened && (
				<ZoomMenuBar
					isMaps={isMaps}
					containerId={containerId}
					mainContainerId={mainContainerId}
					viewMode={viewMode}
					redlineConfiguration={redlineConfiguration}
					graphicActionType={graphicActionType}
					disableOptions={disableOptions}
				/>
			)}
			{isDesignMode && isBirdEyeOpened && <MiniMap />}
			<MapNamesBar />
		</>
	);
};
